/* Выезжающая корзина weralis (09.10). Разметка и весь расчёт — в секции
   `weralis-cart-drawer`; скрипт только открывает панель, шлёт изменения в
   Cart API и подменяет содержимое панели готовым HTML секции.
   Без скрипта ссылка корзины в шапке ведёт на /cart — там то же самое. */
(function () {
  var SECTION = 'weralis-cart-drawer';
  var root, lastFocus;

  function el() { return document.getElementById('WeralisCart'); }

  function open() {
    root = el(); if (!root) return false;
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-open'); }); });
    var panel = root.querySelector('.wcd-panel');
    setTimeout(function () { panel && panel.focus(); }, 60);
    return true;
  }

  function close() {
    root = el(); if (!root || root.hidden) return;
    root.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { root.hidden = true; }, 320);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function setCount(n) {
    document.querySelectorAll('header a[href$="/cart"] .cnt').forEach(function (c) { c.textContent = n; c.classList.toggle('is-zero', +n === 0); });
  }

  function swap(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('#WeralisCart');
    root = el();
    if (!fresh || !root) return;
    root.querySelector('.wcd-panel').innerHTML = fresh.querySelector('.wcd-panel').innerHTML;
    root.dataset.count = fresh.dataset.count;
    setCount(fresh.dataset.count);
  }

  function busy(on) { root = el(); if (root) root.classList.toggle('is-busy', on); }

  function fail() {
    busy(false);
    var e = el() && el().querySelector('.wcd-err');
    if (e) e.hidden = false;
  }

  function post(url, body) {
    body.sections = SECTION;
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    });
  }

  function refresh() {
    return fetch(window.location.pathname + '?sections=' + SECTION)
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (j) { swap(j[SECTION]); });
  }

  function change(key, qty) {
    busy(true);
    return post('/cart/change.js', { id: key, quantity: Math.max(0, qty) })
      .then(function (j) { swap(j.sections && j.sections[SECTION]); busy(false); })
      .catch(fail);
  }

  function add(variantId) {
    busy(true);
    return post('/cart/add.js', { items: [{ id: Number(variantId), quantity: 1 }] })
      .then(function (j) { swap(j.sections && j.sections[SECTION]); busy(false); })
      .catch(fail);
  }

  /* Набор вместо частей: сначала убрать заменяемые штуки одним update по ключам,
     потом положить набор. Если добавление набора упало — вернуть части обратно. */
  function upgrade(btn) {
    busy(true);
    var updates = {};
    updates[btn.dataset.line] = Number(btn.dataset.lineQty);
    if (btn.dataset.mate) updates[btn.dataset.mate] = Number(btn.dataset.mateQty);
    var undo = {};
    undo[btn.dataset.line] = Number(btn.dataset.lineQty) + 1;
    if (btn.dataset.mate) undo[btn.dataset.mate] = Number(btn.dataset.mateQty) + 1;
    fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return post('/cart/add.js', { items: [{ id: Number(btn.dataset.set), quantity: 1 }] })
        .then(function (j) { swap(j.sections && j.sections[SECTION]); busy(false); })
        .catch(function () {
          return fetch('/cart/update.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: undo })
          }).then(refresh).then(fail, fail);
        });
    }).catch(fail);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var icon = t.closest && t.closest('header a[href$="/cart"]');
    if (icon && !/\/cart\/?$/.test(window.location.pathname)) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      if (open()) e.preventDefault();
      return;
    }
    if (!el() || !el().contains(t)) return;
    if (t.closest('[data-wcd-close]')) { close(); return; }
    var q = t.closest('[data-wcd-qty]');
    if (q) { change(q.dataset.key, Number(q.dataset.wcdQty)); return; }
    var a = t.closest('[data-wcd-add]');
    if (a) {
      var sel = el().querySelector('[data-wcd-addon-select]');
      add(sel ? sel.value : a.dataset.wcdAdd); return;
    }
    var u = t.closest('[data-wcd-upgrade]');
    if (u) { upgrade(u); }
  });

  /* Цена на кнопке дополнения — цена выбранного варианта (у лампы $44 и $52). */
  document.addEventListener('change', function (e) {
    var s = e.target.closest && e.target.closest('[data-wcd-addon-select]');
    if (!s) return;
    var b = el() && el().querySelector('[data-wcd-add]');
    var o = s.options[s.selectedIndex];
    if (b && o && o.dataset.price) b.textContent = 'Add · ' + o.dataset.price;
  });

  document.addEventListener('keydown', function (e) {
    root = el();
    if (!root || root.hidden) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var f = root.querySelectorAll('.wcd-panel a[href], .wcd-panel button:not([disabled]), .wcd-panel select');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
    else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
  });

  window.weralisCart = { open: open, close: close, refresh: refresh };
})();
